export const deliverySelectionModalSize = {
  desktop: {
    width: 980,
    height: 247,
  },
  tablet: {
    width: 652,
    height: 240,
  },
};

export const deliverySelectionMyModalSize = {
  desktop: {
    width: 980,
    height: 247,
  },
  tablet: {
    width: 652,
    height: 240,
  },
};

const desktopContentOffset = 137;
const desktopDefaultModalHeight = '70vh';

export const defaultModalSize = {
  desktop: {
    height: desktopDefaultModalHeight,
    width: 752,
    contentHeight: `calc(${desktopDefaultModalHeight} - ${desktopContentOffset}px)`,
  },
  tablet: {
    height: 680,
    width: 640,
    contentHeight: 561,
  },
  mobile: {
    contentMinHeight: 428,
    offset: 128,
  },
};

export const choiceSelectionModalSize = {
  width: 375,
};

export const mobileContentContainerHeight = (
  contentContainerRef,
  isMobile,
  modalRef,
  offset = defaultModalSize.mobile.offset,
  plus = 0
) => {
  if (contentContainerRef && isMobile) {
    contentContainerRef.current.style.height = `${((modalRef.current?.clientHeight || 0) - offset) + plus}px`;
  }
};
